import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, includes } from "lodash";

const PropertyAddAssetServicesDataComponent = (props) => {
    const { role, addPropertyManagementSection, property } = props;

    return (
        <React.Fragment>
            <Container>
                <ContentWrapper>
                    <PropertyManagement>
                        <PropertyManagementHeader>There is no asset services data</PropertyManagementHeader>
                        {includes(["transition", "dataAdmin", "dataEntry"], role) && (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => addPropertyManagementSection(get(property, "propertyKey", null))}
                            >
                                Add Asset Services Data
                            </Button>
                        )}
                    </PropertyManagement>
                </ContentWrapper>
            </Container>
        </React.Fragment>
    );
};

const Container = styled("div")({
    display: "flex",
    width: "100%",
});

const ContentWrapper = styled("div")({
    flex: "1 1 auto",
    padding: "16px",
    border: "2px dashed #dbdbdb",
    marginTop: "15px"
});

const PropertyManagement = styled("div")({
    textAlign: 'center',
    fill: '#9e9e9e',
});

const PropertyManagementHeader = styled("h4")({
    textAlign: 'center',
    fill: '#9e9e9e',
});

export default PropertyAddAssetServicesDataComponent;